import Head from 'next/head'
import { useMemo } from 'react'
import { ILevels } from '../components/Player/Models/PlayerModels'
import { ITag, IWriter } from '../types'

interface IIdxMetaTag {
  name: string
  content: string
}
interface IdxMetaTagsProps {
  title?: string
  path: string
  author?: IWriter[]
  description?: string
  categoryLevels?: ILevels
  tags?: ITag[] | undefined
}
const defaultTitle = 'חדשות, טלוויזיה, דיגיטל, שידור חי | רשת 13'
const defaultDescription =
  'אתר התוכן של ערוץ רשת 13. חדשות 13, האח הגדול, משחקי השף, הישרדות ועוד תוכניות רשת, דיגיטל, אוכל, VOD, שידור חי והתכנים הכי מעניינים בישראל'

const pageLevels = (categoryLevels: ILevels, isItem: boolean) => {
  const response: string[] = []
  if (categoryLevels) {
    const entries = Object.entries(categoryLevels).filter(
      ([key, value]) => key.endsWith('_eng') && value != null
    )

    if (entries.length === 1) {
      response.push('reshet13')
    } else {
      entries.forEach(([key, value], index) => {
        if ((isItem && index === entries.length - 1) || index === 0) {
          return
        }
        const levelStr =
          key === 'level_0_eng' && value?.toLowerCase() == 'main'
            ? 'reshet13'
            : value
        levelStr && response.push(levelStr)
      })
    }
  } else {
    response.push('reshet13')
  }
  return response
}
const isItem = (path: string) => {
  // Pattern 1: /item/<number 6+ digits>
  const itemPattern = /^\/item\/?/

  // Pattern 2: /allshows/series/<series>/season/<season>/<number 6+ digits>
  const allShowsPattern = /^\/allshows\/series\/\d+\/season\/\d+\/\d{6,}\/?$/

  return itemPattern.test(path) || allShowsPattern.test(path)
}
export const IdxMetaTags = ({
  path,
  title = defaultTitle,
  description = defaultDescription,
  author,
  categoryLevels,
  tags,
}: IdxMetaTagsProps) => {
  const metaTags = useMemo(() => {
    const metaTags: IIdxMetaTag[] = [
      {
        name: 'dmp-url',
        content: `https://13tv.co.il${path.split('?')[0]}`,
      },
      { name: 'dmp-title', content: title || defaultTitle },
      { name: 'dmp-domain', content: '13tv.co.il' },
      { name: 'dmp-description', content: description || defaultDescription },
    ]
    let categoryContent
    const cleanPath = path.split('?')[0].split('#')[0]
    if (categoryLevels) {
      categoryContent = pageLevels(categoryLevels, isItem(cleanPath))
    } else {
      const t: ILevels = {}
      path.split('/').forEach((p, index) => {
        if (p) {
          t[`level_${index}_eng` as keyof ILevels] = p
        } else if (index === 0 && !p) {
          t[`level_${index}_eng` as keyof ILevels] = 'MAIN'
        }
      })
      categoryContent = pageLevels(t, isItem(cleanPath))
    }
    metaTags.push({ name: 'dmp-category', content: categoryContent.join(', ') })

    const authorContent =
      author?.map(writer => writer.name).join(', ') || 'רשת 13'
    metaTags.push({ name: 'dmp-author', content: authorContent })

    const tagContent = tags?.map(tag => tag.name).join(', ') || 'רשת 13'
    metaTags.push({ name: 'dmp-tags', content: tagContent })

    return metaTags.map((tag: IIdxMetaTag) => (
      <meta name={tag.name} content={tag.content} key={tag.name} />
    ))
  }, [author, categoryLevels, description, path, tags, title])

  return <Head>{metaTags}</Head>
}
